import { render, staticRenderFns } from "./SensorDataTable.vue?vue&type=template&id=77245caf&scoped=true&"
import script from "./SensorDataTable.vue?vue&type=script&lang=js&"
export * from "./SensorDataTable.vue?vue&type=script&lang=js&"
import style0 from "./SensorDataTable.vue?vue&type=style&index=0&id=77245caf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77245caf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VSimpleTable})
